<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@use './SeoView';
@use '../../Breadcrumb/Breadcrumb';
@use '../../LinkList/LinkList';
@use '../../LinkListAlphabetic/LinkListAlphabetic';
@use '../../ArticleItem/ArticleItem';
@use '../../ArticleContainer/ArticleContainer';
</style>
